// extracted by mini-css-extract-plugin
export default {"container":"ContactAdd_container__DuOzy","bg":"ContactAdd_bg__VJlIH","heading":"ContactAdd_heading__NHEKE"};